import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  fetchAssets,
  fetchPairs,
} from '../actions';

class LoadAssets extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchAssets());
    dispatch(fetchPairs());
  }

  render() {
    const { assets, pairs } = this.props;
    return this.props.children;
  }
}

const mapStateToProps = (state) => ({
  assets: state.assets.assets,
  pairs: state.assets.pairs,
  errors: state.assets.errors,
});

export default withRouter(connect(mapStateToProps)(LoadAssets));
